import calculRepartitionTva from '@/services/devisCommandes/calcul/calculRepartitionTva';
import calculLigneNormalDevis from '@/services/devisCommandes/calcul/calculLigneCommandeNormal';
import calculLigneRemiseDevis from '@/services/devisCommandes/calcul/calculLigneCommandeTypeRemise';
import calculLigneSousTotalDevis from '@/services/devisCommandes/calcul/calculSousTotal';
import calculLignePersonnalise from '@/services/devisCommandes/calcul/calculLignePersonnalise';
import calculLigneCommandeRegroupement from '@/services/devisCommandes/calcul/calculLigneCommandeRegroupement';
import calculArrondi from '@/services/calcul/calculArrondi';
import * as devisConf from '@/configuration/devisConf';
import { SANS_SUITE, INDISPONIBLE, ANNULATION } from '@/configuration/optionBlocage/optionBlocage';
import isLigneRegroupement from '@/services/devisCommandes/isLigneRegroupement';
import findAndCalculHonoraire from '@/services/devisCommandes/calcul/findAndCalculHonoraire';

export default function calculCommandeDevis(devisCommande) {
  if (!devisCommande) {
    return;
  }
  devisCommande.montantHt = 0;
  let listeLigneCommande = null;
  if (devisCommande.lignesCommande) {
    listeLigneCommande = devisCommande.lignesCommande;
    listeLigneCommande.forEach((ligne) => {
      if (ligne.type === devisConf.REGROUPEMENT && ligne.lignesCommande) {
        listeLigneCommande = listeLigneCommande.concat(ligne.lignesCommande);
      }
    });
    listeLigneCommande.sort((a, b) => {
      return a.ordre - b.ordre;
    });
    listeLigneCommande
      .filter((ligneCommande) => {
        return ligneCommande.type === devisConf.NORMAL;
      })
      .forEach((ligneCommande) => {
        calculLigneNormalDevis(ligneCommande);
        ligneCommande.totalHtAvecLigneRemise = ligneCommande.totalHt;
      });

    findAndCalculHonoraire(listeLigneCommande);

    listeLigneCommande.forEach((ligne) => {
      if (ligne.type === devisConf.REGROUPEMENT && ligne.lignesCommande) {
        calculLigneCommandeRegroupement(ligne);
      }
    });

    calculLigneRemiseDevis(listeLigneCommande);

    listeLigneCommande
      .filter((ligneCommande) => {
        return ligneCommande.type === devisConf.SOUS_TOTAL;
      })
      .forEach((ligneCommande) => {
        calculLigneSousTotalDevis(ligneCommande,
          listeLigneCommande.slice(0,
            listeLigneCommande.indexOf(ligneCommande) + 1));
      });

    listeLigneCommande
      .filter((ligneCommande) => {
        return ligneCommande.type === devisConf.PERSONNALISE;
      })
      .forEach((ligneCommande) => {
        calculLignePersonnalise(ligneCommande,
          listeLigneCommande.filter(l => l.type !== devisConf.PERSONNALISE));
      });

    listeLigneCommande
      .filter((ligneCommande) => {
        return ligneCommande.type === devisConf.NORMAL || ligneCommande.type === devisConf.REMISE;
      })
      .forEach((ligneCommande) => {
        if ((ligneCommande.etatObtenu === SANS_SUITE
          || ligneCommande.etatObtenu === INDISPONIBLE
          || ligneCommande.etatObtenu === ANNULATION)
          && isLigneRegroupement(devisCommande, ligneCommande.referenceRegroupement)
          && devisCommande.type === devisConf.TYPE_DEVIS) return;
        devisCommande.montantHt = calculArrondi(
          ligneCommande.totalHt + devisCommande.montantHt,
        );
      });
  }
  calculRepartitionTva(devisCommande, listeLigneCommande);
}
